export const TOOL_TIP_PORTAL_CONTAINER_ID = "tooltip-portal-container";